import React from 'react';
import SampleReportForm from './SampleReportForm';
import downloadImage from '../assets/images/download.jpg';

const SampleReportSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={downloadImage}
              alt="Sample Report"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-4xl font-bold mb-6 text-gray-900">
              Get a Sample stock idea research report
            </h2>
            <SampleReportForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SampleReportSection;
